/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckAIcon24Regular = forwardRef('CheckAIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21.077 5.657a.75.75 0 0 1 0 1.06l-10.249 10.25a3.131 3.131 0 0 1-4.428 0L2.595 13.16a.75.75 0 1 1 1.06-1.06l3.806 3.805c.637.637 1.67.637 2.306 0l10.25-10.249a.75.75 0 0 1 1.06 0Z" })));
});
